import {
  countryBrandValueCollectionTile,
  ICollectionTile,
} from "@faire/deprecated-retailer-visitor-shared/components/Carousel/CategoryAndCollectionCarousel/consts";
import {
  getAllBrandsLink,
  getBrandValueLink,
} from "@faire/deprecated-retailer-visitor-shared/consts/allBrandsLinks";
import {
  buildFilterKey,
  MAKER_SPECIAL_FILTER_TYPE,
} from "@faire/deprecated-retailer-visitor-shared/filters/filterKeys";
import { getSessionCountry } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getSessionCountry";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ITestimonial } from "@faire/web-api--source/indigofair/data/ITestimonial";
import { StrictLocalizeFunction } from "@faire/web/common/localization/localize";
import { isNotNull } from "@faire/web/common/typescriptUtils";

export const getOpenWithFaireCollection = (
  strictLocalize: StrictLocalizeFunction,
  isCanadianOrAmerican: boolean
): ICollectionTile[] =>
  [
    countryBrandValueCollectionTile(getSessionCountry(), strictLocalize),
    {
      cta: getBrandValueLink("not-sold-on-amazon"),
      displayName: strictLocalize({
        id: "xFQH7B",
        defaultMessage: "Brands not sold on Amazon",
        description: { text: "Category name" },
      }),
      imageUrl:
        "https://cdn.faire.com/fastly/673e3e2396ebe861807a27891f1354e5993cbe9e9d473cd8e0e31a5b9677c8cb.jpeg",
    },
    {
      cta: "/category/Home%20Decor/subcategory/Candles%20&%20Holders/Candles",
      displayName: strictLocalize({
        id: "YYy2/7",
        defaultMessage: "Candles",
        description: { text: "Category name" },
      }),
      imageUrl:
        "https://cdn.faire.com/fastly/ced81555a95aa0b114baa5874d5c8eb04119a37021c7389eca42fb698df23605.jpeg",
    },
    isCanadianOrAmerican
      ? {
          cta: "/category/Black-Owned%20Businesses",
          displayName: strictLocalize({
            id: "+QGf9r",
            defaultMessage: "Black-Owned Businesses",
            description: { text: "Category name" },
          }),
          imageUrl:
            "https://cdn.faire.com/fastly/548219d54381063c2dae72c05967ec455234ff9986c8bde9cfe0951cd71e992b.jpeg",
        }
      : null,
    {
      cta: "/category/Home%20Decor/subcategory/Home%20Accents",
      displayName: strictLocalize({
        id: "EpFvil",
        defaultMessage: "Home Accents",
        description: { text: "Category name" },
      }),
      imageUrl:
        "https://cdn.faire.com/fastly/f211eaf0ac50ea9c208705f6a9e05177962b29282cf09417e8ed041c92db6e52.jpeg",
    },
    {
      cta: getBrandValueLink("eco-friendly"),
      displayName: strictLocalize({
        id: "uEZIG+",
        defaultMessage: "Eco-friendly Brands",
        description: { text: "Category name" },
      }),
      imageUrl:
        "https://cdn.faire.com/fastly/749ffe09238499ddd51da5399555e1a3e14c757e1b06e3829306ae36dbb1df2d.jpeg",
    },
    {
      cta: getAllBrandsLink({
        filters: [buildFilterKey(MAKER_SPECIAL_FILTER_TYPE, "free_shipping")],
      }),
      displayName: strictLocalize({
        id: "PEoSW0",
        defaultMessage: "Brands with Free Shipping",
        description: { text: "Category name" },
      }),
      imageUrl:
        "https://cdn.faire.com/fastly/a2406cbad6fbf089b9bca7689882ca6ed98020bb3a8c6c8d11d0d4b13e8b5043.jpeg",
    },
  ].filter(isNotNull);

export const FALLBACK_NAM_TESTIMONIALS = (
  strictLocalize: StrictLocalizeFunction
): ITestimonial[] => [
  ITestimonial.build({
    image: IImage.build({
      url: "https://cdn.faire.com/fastly/7c3002c45f25c36ce686d4388f42eaa8ef31ac1e791d89efbc03995e426f124e.png",
    }),
    testimony: strictLocalize({
      id: "7jrCb2",
      defaultMessage:
        "“I opened my second location in under 6 weeks. Having that credit line, along with thousands of brands to shop all in one place, really helped us get off the ground!”",
      description: {
        text: "Testimonial from retailer that Open with Faire was very helpful to them. Quotes should be localized.",
      },
    }),
    author: strictLocalize({
      id: "fZrorW",
      defaultMessage: "Janel Anderson",
      description: { text: "Name of the owner of a retailer" },
    }),
    retailer_name: strictLocalize({
      id: "0t0+WU",
      defaultMessage: "Stitch + Sparrow",
      description: { text: "Name of a retailer's store" },
    }),
  }),
  ITestimonial.build({
    image: IImage.build({
      url: "https://cdn.faire.com/fastly/e843d17b4a24e3a6ea34ebc398fcdb79b578d53d4534546996a3992b297b3c9f.png",
    }),
    testimony: strictLocalize({
      id: "vKTiTd",
      defaultMessage:
        "“In the midst of building the space and hiring employees for my store, I was under financial and time constraints. These funds were a critical part of opening my shop.”",
      description: {
        text: "Testimonial from retailer that Open with Faire was very helpful to them. Quotes should be localized.",
      },
    }),
    author: strictLocalize({
      id: "dexc8v",
      defaultMessage: "Ferzan Jaeger",
      description: { text: "Name of the owner of a retailer" },
    }),
    retailer_name: strictLocalize({
      id: "GIR2sf",
      defaultMessage: "Olive & Loom",
      description: { text: "Name of a retailer's store" },
    }),
  }),
  ITestimonial.build({
    image: IImage.build({
      url: "https://cdn.faire.com/fastly/06f4cd4e6c8d5311687849c44265d966e500aaf40e162f9808a6bb9012a98677.png",
    }),
    testimony: strictLocalize({
      id: "4ZwGHz",
      defaultMessage:
        "“We were able to fill a space full of products that fit our company’s ethos with these generous net terms. Faire has been an indispensable resource to open our shop.”",
      description: {
        text: "Testimonial from retailer that Open with Faire was very helpful to them. Quotes should be localized.",
      },
    }),
    author: strictLocalize({
      id: "ZvovYn",
      defaultMessage: "Melina LaVecchia",
      description: { text: "Name of the owner of a retailer" },
    }),
    retailer_name: strictLocalize({
      id: "7lrWUy",
      defaultMessage: "Common Good Co.",
      description: { text: "Name of a retailer's store" },
    }),
  }),
  ITestimonial.build({
    image: IImage.build({
      url: "https://cdn.faire.com/fastly/5dbb1c13e5c89ad4098d56daa460975045647a884bab0a65f9a73cd62e70ec64.png",
    }),
    testimony: strictLocalize({
      id: "h2ZI4o",
      defaultMessage:
        "“Having a sizable terms limit, as well as Faire’s well-developed ordering technology and superb customer service, were critical to our new store’s success.”",
      description: {
        text: "Testimonial from retailer that Open with Faire was very helpful to them. Quotes should be localized.",
      },
    }),
    author: strictLocalize({
      id: "KkyPeQ",
      defaultMessage: "Susan Felker",
      description: { text: "Name of the owner of a retailer" },
    }),
    retailer_name: strictLocalize({
      id: "WN+KK1",
      defaultMessage: "Prairie Kitchen Store",
      description: { text: "Name of a retailer's store" },
    }),
  }),
];
